import { AxiosResponse } from "axios";
import mime from "mime";

export const getFileNameFromHeaders = (response: AxiosResponse) => {
    const contentDisposition = response.headers["content-disposition"];
    if (!contentDisposition) return null;
    const fileName = contentDisposition.split("filename=")[1].split(";")[0];

    const contentType = response.headers["content-type"];
    if (!contentType) return fileName;

    const fileExtension = mime.getExtension(contentType);
    return `${fileName}.${fileExtension}`;
};

export const createDownloadBlob = (data: Blob, fullPath: string) => {
    const url = window.URL.createObjectURL(new Blob([data], { type: data.type }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fullPath);
    document.body.appendChild(link);
    link.click();
    link.remove();
};
